import React from "react";
import {useSelector} from "react-redux";
import {Button} from "primereact/button";
import {useNavigate} from "react-router-dom";
import {useTranslate} from "../../system/useTranslate";

export default function Overview() {
    const translate = useTranslate();
    const navigate = useNavigate();
    const membership = useSelector((state) => state.app.workspaceMembershipData);
    const workspace = membership?.workspace;
    const role = (membership?.user_roles || []).find((item) => item.scope_type === "workspace");

    return (
        <div className="h-full overflow-auto p-4 md:p-6">
            <div className="surface-card border-1 border-200 border-round-2xl p-4 md:p-6 flex flex-column gap-4">
                <div className="flex align-items-center gap-3">
                    <span className="w-4rem h-4rem border-circle bg-primary flex align-items-center justify-content-center text-white"><i className="pi pi-building text-2xl"/></span>
                    <div className="flex flex-column gap-1"><h1 className="m-0 text-2xl">{workspace?.name}</h1><span className="text-sm text-500">{translate("workspace-overview-description")}</span></div>
                </div>
                <div className="grid">
                    <div className="col-12 md:col-4"><Info label={translate("workspace-id")} value={workspace?.documentId}/></div>
                    <div className="col-12 md:col-4"><Info label={translate("role")} value={role?.role}/></div>
                    <div className="col-12 md:col-4"><Info label={translate("status")} value={workspace?.workspaceStatus || "active"}/></div>
                </div>
                <div className="flex flex-wrap gap-2">
                    <Button className="text-xs gap-2" icon="pi pi-users" label={translate("manage-members")} onClick={() => navigate("/settings?tab=manage-members")}/>
                    <Button className="text-xs gap-2" outlined icon="pi pi-code" label={translate("developer-extension-guide")} onClick={() => navigate("/developer")}/>
                </div>
            </div>
        </div>
    );
}

function Info({label, value}) {
    return <div className="surface-50 border-round-xl p-3 flex flex-column gap-2"><span className="text-xs text-500">{label}</span><span className="font-semibold text-sm text-900">{value || "—"}</span></div>;
}
